<div class="trip-summary-container">
  <!-- Page Header with Back Navigation -->
  <div class="page-header-section">
    <div class="back-navigation">
      <button mat-button (click)="onBack()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
        Back to Billing Management
      </button>
    </div>

    <app-page-header
      [title]="'Trip Summary'"
      [subtitle]="totalTrips + ' trips selected for billing'"
      [showDate]="false"
    ></app-page-header>
  </div>

  <div class="summary-content">
    <div class="summary-grid">
      <!-- Selected Trips Section -->
      <div class="selected-trips-section">
        <div class="section-header">
          <h3>
            <mat-icon>receipt_long</mat-icon>
            Selected Trips
          </h3>
        </div>

        <div class="table-container">
          <div class="mat-table-wrapper">
            <table
              mat-table
              [dataSource]="selectedTrips"
              class="mat-elevation-z2"
              [class.sticky-header]="true"
            >
              <!-- S.No Column -->
              <ng-container matColumnDef="sno">
                <th mat-header-cell *matHeaderCellDef class="sno-header">
                  S.No
                </th>
                <td
                  mat-cell
                  *matCellDef="let trip; let i = index"
                  class="sno-cell"
                >
                  {{ i + 1 }}
                </td>
              </ng-container>

              <!-- Route Name Column -->
              <ng-container matColumnDef="routeName">
                <th mat-header-cell *matHeaderCellDef class="route-header">
                  Route Name
                </th>
                <td mat-cell *matCellDef="let trip" class="route-name">
                  {{ trip.routeName }}
                </td>
              </ng-container>

              <!-- Driver Column -->
              <ng-container matColumnDef="driver">
                <th mat-header-cell *matHeaderCellDef class="driver-header">
                  Driver
                </th>
                <td mat-cell *matCellDef="let trip">
                  {{ trip.driverDetails.driverName || "N/A" }}
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef class="date-header">
                  Date
                </th>
                <td mat-cell *matCellDef="let trip">
                  {{ trip.tripStartDate | date : "dd/MM/yyyy" }}
                </td>
              </ng-container>

              <!-- Vehicle Column -->
              <ng-container matColumnDef="vehicle">
                <th mat-header-cell *matHeaderCellDef class="vehicle-header">
                  Vehicle
                </th>
                <td mat-cell *matCellDef="let trip">
                  {{ trip.vehicleDetails.vehicleNumber || "N/A" }}
                  ({{ trip.vehicleDetails.fleetType || "N/A" }})
                </td>
              </ng-container>

              <!-- Distance Column -->
              <ng-container matColumnDef="distance">
                <th mat-header-cell *matHeaderCellDef class="distance-header">
                  Distance
                </th>
                <td mat-cell *matCellDef="let trip" class="distance-cell">
                  {{ trip.distance ? trip.distance + " km" : "N/A" }}
                </td>
              </ng-container>

              <!-- Rate Card Type Column -->
              <ng-container matColumnDef="rateCardType">
                <th mat-header-cell *matHeaderCellDef class="rate-card-header">
                  Rate Card Type
                </th>
                <td mat-cell *matCellDef="let trip" class="rate-card-cell">
                  {{ getRateCardTypeLabel(trip.rateCardType) }}
                </td>
              </ng-container>

              <!-- Rate/km Column -->
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef class="price-header">
                  Rate
                </th>
                <td mat-cell *matCellDef="let trip" class="price-cell">
                  {{
                    trip.price > 0 ? "₹" + trip.price.toLocaleString() : "N/A"
                  }}
                </td>
              </ng-container>

              <!-- Cost Column -->
              <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef class="cost-header">
                  Total Amount
                </th>
                <td mat-cell *matCellDef="let trip" class="cost-cell">
                  {{ formatCurrency(trip.vehicleDetails.cost) }}
                </td>
              </ng-container>

              <!-- Header and Data Rows -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Vendor Details & Cost Summary Section -->
      <div class="vendor-summary-section">
        <!-- Vendor Details -->
        <div class="vendor-details-section">
          <div class="section-header">
            <h3>
              <mat-icon>business</mat-icon>
              Vendor Details
            </h3>
            <div class="header-actions">
              <button
                mat-icon-button
                (click)="editVendorDetails()"
                class="edit-btn"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>

          <div class="vendor-display" *ngIf="!isEditingVendor">
            <div class="vendor-info" *ngIf="!loadingVendor">
              <div class="vendor-name">
                {{
                  vendorForm.get("vendorName")?.value ||
                    "No vendor details available"
                }}
              </div>
              <div class="service-type">
                {{
                  vendorForm.get("serviceType")?.value ||
                    "Click edit to add vendor details"
                }}
              </div>
            </div>

            <div class="vendor-loading" *ngIf="loadingVendor">
              <mat-spinner diameter="20"></mat-spinner>
              <span>Loading vendor details...</span>
            </div>

            <div class="bank-details" *ngIf="!loadingVendor">
              <div class="detail-item">
                <span class="label">Bank Name:</span>
                <span class="value">{{
                  vendorForm.get("bankName")?.value || "Not available"
                }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Account No:</span>
                <span class="value">{{
                  vendorForm.get("accountNo")?.value || "Not available"
                }}</span>
              </div>
              <div class="detail-item">
                <span class="label">IFSC Code:</span>
                <span class="value">{{
                  vendorForm.get("ifscCode")?.value || "Not available"
                }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Account Holder:</span>
                <span class="value">{{
                  vendorForm.get("accountHolder")?.value || "Not available"
                }}</span>
              </div>
            </div>
          </div>

          <form
            [formGroup]="vendorForm"
            class="vendor-form"
            *ngIf="isEditingVendor"
          >
            <div class="form-row">
              <div class="form-field">
                <app-mat-input
                  [control]="vendorForm.get('vendorName')"
                  label="Vendor Name"
                  placeholder="Enter vendor name"
                  [required]="true"
                ></app-mat-input>
              </div>

              <div class="form-field">
                <app-mat-input
                  [control]="vendorForm.get('serviceType')"
                  label="Service Type"
                  placeholder="Enter service type"
                  [required]="true"
                ></app-mat-input>
              </div>
            </div>

            <div class="form-row">
              <div class="form-field">
                <app-mat-input
                  [control]="vendorForm.get('bankName')"
                  label="Bank Name"
                  placeholder="Enter bank name"
                  [required]="true"
                ></app-mat-input>
              </div>

              <div class="form-field">
                <app-mat-input
                  [control]="vendorForm.get('accountNo')"
                  label="Account No"
                  placeholder="Enter account number"
                  [required]="true"
                ></app-mat-input>
              </div>
            </div>

            <div class="form-row">
              <div class="form-field">
                <app-mat-input
                  [control]="vendorForm.get('ifscCode')"
                  label="IFSC Code"
                  placeholder="Enter IFSC code"
                  [required]="true"
                ></app-mat-input>
              </div>

              <div class="form-field">
                <app-mat-input
                  [control]="vendorForm.get('accountHolder')"
                  label="Account Holder"
                  placeholder="Enter account holder name"
                  [required]="true"
                ></app-mat-input>
              </div>
            </div>

            <div class="form-actions">
              <button
                type="button"
                mat-button
                (click)="saveVendorDetails()"
                class="save-btn"
              >
                <mat-icon>save</mat-icon>
                Save
              </button>
              <button
                type="button"
                mat-button
                (click)="cancelEdit()"
                class="cancel-btn"
              >
                <mat-icon>close</mat-icon>
                Cancel
              </button>
            </div>
          </form>
        </div>

        <!-- Cost Summary -->
        <div class="cost-summary-section">
          <div class="section-header">
            <h3>
              <mat-icon>calculate</mat-icon>
              Cost Summary
            </h3>
          </div>

          <div class="summary-details">
            <div class="summary-item">
              <span class="label">Total Trips:</span>
              <span class="value">{{ totalTrips }}</span>
            </div>

            <div class="summary-item">
              <span class="label">Total Distance:</span>
              <span class="value">{{ totalDistance }} km</span>
            </div>

            <div class="summary-item total-cost">
              <span class="label">Total Cost:</span>
              <span class="value">{{ formatCurrency(totalCost) }}</span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="onProceedToBillGeneration()"
              [disabled]="vendorForm.invalid"
              class="proceed-button"
            >
              <mat-icon>receipt</mat-icon>
              Proceed to Bill Generation
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
